// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_G43","left":"styles_left__2gSAM"};